import React, { useEffect, useState, useCallback } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { runCompletedRoutesIntroTour, COMPLETED_ROUTES_TOUR_KEY } from "./introTour";
import { addClassToElement as waitAndAddClass } from "../../utils/addClassToElement";


export default function CompletedRoutes({ title , isAppReady, appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings}) {

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);
  console.log(process.env.REACT_APP_PUBLIC_URL);

  /**
   * Prepare all DOM elements that are used as tour targets:
   * waits for each selector and adds the corresponding class (with timeout).
   * Uses the shared util: utils/addClassToElement.js
   */
  const prepareTourTargets = useCallback(async () => {
    const tasks = [
    ];

    // We don't want a single failure to block the tour forever → allSettled.
    const results = await Promise.allSettled(tasks);

    // Optional: log which selectors failed (timeout) for debugging.
    results.forEach((res, idx) => {
      if (res.status === "rejected") {
        console.warn(
          "[prepareTourTargets] Failed for task index",
          idx,
          res.reason
        );
      }
    });
  }, []);

  /**
   * Manual start via button:
   * - clear home tour flag
   * - wait for all tour targets to be ready (up to each timeout)
   * - start intro.js tour
   */
  const handleStartTourClick = async () => {
    console.log("CompletedRoutes tour button clicked, resetting the tour...");
    localStorage.removeItem(COMPLETED_ROUTES_TOUR_KEY);

    await prepareTourTargets();
    runCompletedRoutesIntroTour(menuItemsStrings);
  };

  /**
   * Auto-start on first visit when:
   * - home tour not completed
   * - app ready
   * - desktop layout
   * - URL matches expected
   *
   * No custom loops here: we just call the async helper once.
   */
  useEffect(() => {
    const maybeStartTour = async () => {
      console.log("Current Location:", window.location);

      const hasCompletedTour = localStorage.getItem(COMPLETED_ROUTES_TOUR_KEY);
      const mediaQuery = window.matchMedia("(min-width: 1200px)");

      const isCorrectHref =
        window.location.href === `${process.env.REACT_APP_API_TOUR}/#/completedRoutes`;
      const isEmptySearch = window.location.search === "";

      console.log("isAppReady:", isAppReady);
      console.log("hasCompletedTour:", hasCompletedTour);
      console.log("mediaQuery.matches:", mediaQuery.matches);
      console.log("isCorrectHref:", isCorrectHref);
      console.log("isEmptySearch:", isEmptySearch);

      if (
        !hasCompletedTour &&
        isAppReady &&
        mediaQuery.matches &&
        isCorrectHref &&
        isEmptySearch
      ) {
        await prepareTourTargets();
        runCompletedRoutesIntroTour(menuItemsStrings);
      }
    };

    maybeStartTour();
  }, [isAppReady, prepareTourTargets, menuItemsStrings]);

  return (
    <section className="content tour-homepage-page">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <h6 className="page-disclaimer"> {appDisclaimer} </h6> */}
          </div>
          <div className="col-md-2 col-sm-3 col-2 d-flex justify-content-end">
             <button 
              onClick={handleStartTourClick} 
              className="start-tour-button"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {isHovered ? (
                <>
                  {menuItemsStrings.tourParamsTourStartButton} 
                  <FontAwesomeIcon icon="circle-play" className="ml-2" /> 
                </>
              ) : (
                <FontAwesomeIcon icon="circle-play" /> 
              )}
            </button>
          </div>
        </div>
      </div>

      <div className="container-fluid">



        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

              <div className="row justify-content-left">
                {/* LFL/Periods Row */}

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      {/* Period selector */}
                      <QlikCard
                        id="52eb5675-65f5-4d7a-ac4a-08e795512a14"
                        height="36px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        showOverlayer={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                      {/* Additional info */}
                      <QlikCard
                        id="Wgvc"
                        height="36px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        showOverlayer={false}
                      />
                    </div>



              </div>

              <div className="row justify-content-left tour-completedRoutes-kpi-row resize-grid-kpi-row-completed-routes">
                {/* KPIs Row */}

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 tour-completedRoutes-kpi-no-of-flights">
                      {/* KPI: schedule completion */}
                      <QlikCard
                        id="naxjeB"
                        height="120px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        showOverlayer={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                      {/* KPI: no of units in use */}
                      <QlikCard
                        id="98cd7f5f-eff6-4340-8174-5dcea6981bed"
                        height="120px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        showOverlayer={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                      {/* KPI: routes completion */}
                      <QlikCard
                        id="6116962a-6df0-4018-969f-7c987693ba7c"
                        height="120px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        showOverlayer={false}
                      />
                    </div>

{/*                     <div className="col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                      <QlikCard
                        id="jxkPn"
                        height="120px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        showOverlayer={false}
                      />
                    </div> */}

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                      {/* KPI: no of transporters */}
                      <QlikCard
                        id="5678f11d-5638-4060-8bd9-9ef95ae68bb9"
                        height="120px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        showOverlayer={false}
                      />
                    </div>

              </div>


              <div className="row justify-content-left resize-grid-chart-row-completed-routes">
                {/* Charts Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                  {/* barchart column */}
                  <div className="row justify-content-center ">
                    <div className="col-12">
                      {/* barchart */}
                      <QlikCard
                        id="be9f9756-bd47-4f32-997a-9c9b42b90a57"
                        height="max(calc(80vh - 263px - 40px - 30px), 150px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                  {/* pie chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* pie chart */}
                      <QlikCard
                        id="92377fa9-6bb8-4fd2-ae4c-0a762bed6e98"
                        height="max(calc(80vh - 263px - 40px - 30px), 150px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          console.log(vis);
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  {/* line chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* line chart */}
                      <QlikCard
                        id="26fbe743-3b23-4ae0-a606-f1720f4886ec"
                        // height="294px"
                        height="max(calc(80vh - 263px - 40px - 30px), 150px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          // if(exportType in { pdf: true, image: true} && vis)
                          //   await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

              </div>

              <div className="row justify-content-left">
                {/* Flow Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  {/* flow chart column */}
                  <div className="row justify-content-center tour-completedRoutes-sankey">
                    <div className="col-12">
                      {/* flow chart */}
                      <QlikCard
                        id="2ef37e29-4894-4399-9abb-5667acfa7bd0"
                        height="max(calc(100vh - 263px - 90px), 150px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

              </div>

              <div className="row justify-content-left">
                {/* Table Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  {/* table column */}
                  <div className="row justify-content-center tour-completedRoutes-table">
                    <div className="col-12">
                      {/* table */}
                      <QlikCard
                        id="ajLfCY"
                        height="max(calc(100vh - 263px - 90px), 150px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

              </div>

            </div>


{/*             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 tour-home-filterpane-side">
                  <QlikCard
                    id="GhVZpW"
                    // height="485px"
                    height="max(calc(100vh - 263px - 25px), 100px)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
            </div> */}



          </div>

{/*           <div className="row">
            <div className="col-12">
              <QlikObject
                id="AQtTDP"
                height="0px"
                showLoader={false}
                showOverlayer={false}
              />
            </div>
          </div> */}
          
        </div>
    </section>
  );
}
